import { useState, useEffect } from 'react'

let configUpdateListeners = []

export const useConfigUpdate = () => {
  const [updateTrigger, setUpdateTrigger] = useState(0)

  useEffect(() => {
    const listener = () => {
      setUpdateTrigger((prev) => prev + 1)
    }

    configUpdateListeners.push(listener)

    return () => {
      const index = configUpdateListeners.indexOf(listener)
      if (index > -1) {
        configUpdateListeners.splice(index, 1)
      }
    }
  }, [])

  return updateTrigger
}

export const triggerConfigUpdate = () => {
  configUpdateListeners.forEach((listener) => listener())
}
